import { AddressRepository } from './addressRepository'

/**
 * Serviço de consulta de endereços postais.
 */
export class AddressService {
    private addressRepository: AddressRepository

    constructor(addressRepository: AddressRepository) {
        this.addressRepository = addressRepository
    }

    /**
     * Delega a consulta de CEP ao repositório configurado.
     * @param cep CEP contendo 8 dígitos numéricos
     * @returns Endereço correspondente ao CEP
     */
    public async findByCep(cep: string) {
        return await this.addressRepository.findByCep(cep)
    }
}
